import { SolanaAssetIcon, TetherAssetIcon } from 'shared/icons'
import { formatToTether } from 'shared/utils/format-price'
import type { WalletBalance } from '../types'
import { formatSol } from '../utils/format-sol'
import { getFundingState } from '../utils/get-funding-state'
import { FuelGauge } from './fuel-gauge'
import styles from '../neon-wallets.module.scss'

interface Props {
  balance?: WalletBalance
}

const formatUsdt = (usdt: number) =>
  `${formatToTether(Math.trunc(usdt * 100) / 100)} USDT`

/**
 * USDT to play with and SOL, the fuel for network fees. Users fund the
 * wallet themselves, so a tank below the recommended SOL is called out.
 */
export const WalletBalances: React.FC<Props> = ({ balance }) => {
  const { sol, usdt, fuel } = getFundingState(balance)

  return (
    <div className={styles.balances}>
      <div className={styles.balanceTile}>
        <TetherAssetIcon className={styles.balanceIcon} />
        <span className={styles.balanceText}>
          <span className={styles.balanceValue}>
            {balance ? formatUsdt(usdt) : '—'}
          </span>
          <span className={styles.balanceLabel}>To play</span>
        </span>
      </div>

      <div
        className={styles.balanceTile}
        data-fuel={balance ? fuel : undefined}
      >
        <SolanaAssetIcon className={styles.balanceIcon} />
        <span className={styles.balanceText}>
          <span className={styles.balanceValue}>
            {balance ? formatSol(sol) : '—'}
          </span>
          <span className={styles.balanceLabel}>Fuel for fees</span>
        </span>
        {balance ?
          <FuelGauge
            sol={sol}
            state={fuel}
          />
        : null}
      </div>

      {balance && fuel !== 'full' ?
        <span
          className={styles.fuelHint}
          data-state={fuel}
        >
          {fuel === 'empty' ?
            'Out of fuel: add SOL to pay the network fees'
          : 'Low on fuel: add SOL for the network fees'}
        </span>
      : null}
    </div>
  )
}
